export default "__VITE_ASSET__f1f4a9b9__"